<template>
    <v-container fluid style="margin: 0px 10% 60px 10%" v-if="asesoria">
      <vueHeadful
      :title="this.$i18n.t('Menu.CreativeCommons') + ' - TrArtist'"
      :url="'https://trartist.com' + $route.fullPath"
      />
        <v-row>
            <v-col cols="6" xs="4" md="4" style="margin-left: auto; margin-right: auto;">
              <v-img src="https://firebasestorage.googleapis.com/v0/b/trartist-com.appspot.com/o/utilidades%2Fcreativecommons%2Fcreative-commons.jpg?alt=media&token=87913de0-5da6-4d2d-83d3-8482b181a58b" contain />
            </v-col>
            <v-col cols="12" xs="12" :md="asesoria.secundaria ? '6' : '12'" align-self="flex-start" style="text-align: justify;">
              <div class="textoMagazine" v-html="asesoria.descripcionEs" v-if="getIdioma === 'es'" />
              <div class="textoMagazine" v-html="asesoria.descripcionEn" v-else />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import * as faker from 'faker'
import * as firebase from 'firebase/app'
import 'firebase/firestore'
export default {
  name: 'CreativeCommons',
  data () {
    return {
      asesoria: null,
      formulario: {
        uid: faker.random.alphaNumeric(8).toUpperCase(),
        nombre: null,
        pais: null,
        departamento: null,
        ciudad: null,
        telefono: null,
        correo: null,
        descripcion: null
      }
    }
  },
  mounted () {
    firebase.firestore().collection('utilidades').doc('creativecommons').get().then(info => {
      this.asesoria = info.data()
    })
  },
  methods: {
    ...mapMutations(['setAlerta', 'setTextoAlerta']),
    ...mapActions(['enviarCorreo'])
  },
  computed: {
    ...mapGetters(['getPaises', 'getIdioma']),
    responsiveTitulo () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'font-size:2rem;line-height:2rem;'
        case 'sm': return 'font-size:3rem;line-height:3rem;'
        case 'md': return 'font-size:3rem;line-height:3rem;'
        case 'lg': return 'font-size:4rem;line-height:4rem;'
        case 'xl': return 'font-size:4rem;line-height:4rem;'
        default: return 'font-size:4rem;line-height:4rem;'
      }
    }
  }
}
</script>

<style>
.titulo {
  font-family: 'Be Vietnam', sans-serif!important;
  font-weight: 600!important;
}
.textoMagazine img {
  min-width: 280px;
}
.textoMagazine h2, .ql-editor h2 {
    font-size: 34px!important;
}
</style>
